module.exports = __webpack_public_path__ + "static/media/About2.88dafadc.png";